import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Breadcrumbs from "../common/Breadcrumbs";
import Aos from "aos";

const ServicesPage = () => {
    const routes = all_routes;

    useEffect(() => {
        Aos.init({ duration: 1200, once: true });
    }, []);

    const services = [
        {
            id: 1,
            slug: null as string | null,
            category: "limousine",
            icon: "✦",
            title: "Limousine Service",
            subtitle: "For Special Occasions & VIP Events",
            description:
                "Experience the pinnacle of luxury with our professional chauffeur-driven limousine service. Perfect for weddings, corporate events, galas, and any occasion where only the best will do.",
            features: [
                "Professional, uniformed chauffeurs",
                "Complimentary beverages on board",
                "Flight tracking for airport transfers",
                "Available 24/7, 365 days a year",
                "Meet & Greet service included",
                "Real-time vehicle tracking",
            ],
            cta: "Book a Limousine",
        },
        {
            id: 2,
            slug: null as string | null,
            category: "rental",
            icon: "◈",
            title: "Car Rental",
            subtitle: "Freedom & Flexibility on Your Terms",
            description:
                "Choose from our curated fleet of premium vehicles for self-drive rental. Whether you're exploring Geneva or embarking on a longer journey, our well-maintained cars give you the freedom you need.",
            features: [
                "Comprehensive insurance included",
                "Flexible rental periods (daily to monthly)",
                "Premium fleet — sedans, SUVs & more",
                "Fully fuelled upon collection",
                "Delivery to your location available",
                "Transparent, no-hidden-fee pricing",
            ],
            cta: "Browse Cars",
        },
        {
            id: 3,
            slug: "vip-concierge",
            category: "limousine",
            icon: "✧",
            title: "VIP Concierge Services",
            subtitle: "Private Airport Lounge Access",
            description:
                "Experience true exclusivity from the moment you arrive. We provide access to private airport lounges at Geneva and Zurich airports — a serene, premium environment before your flight.",
            features: [
                "Private lounge access at Geneva & Zurich airports",
                "Dedicated concierge assistance on arrival",
                "Fast-track security & immigration services",
                "Refreshments & business amenities in the lounge",
                "Seamless connection to your Eleego chauffeur",
                "Available 24/7, 365 days a year",
            ],
            cta: "Enquire Now",
        },
        {
            id: 4,
            slug: "hotel-bookings",
            category: "limousine",
            icon: "◈",
            title: "Luxury Hotel Bookings",
            subtitle: "Exclusive 5-Star Reservations",
            description:
                "We handle exclusive reservations at the finest 5-star hotels in Switzerland and Europe upon request — ensuring you arrive to an experience that matches the journey.",
            features: [
                "Curated selection of 5-star & palace hotels",
                "Suite & villa reservations on request",
                "Bespoke amenity arrangements",
                "Corporate & long-stay negotiated rates",
                "Breakfast & dining reservations included",
                "VIP early check-in / late check-out coordination",
            ],
            cta: "Enquire Now",
        },
        {
            id: 5,
            slug: "airline-ticketing",
            category: "limousine",
            icon: "✈",
            title: "Airline Ticketing Services",
            subtitle: "Reservations, Bookings & Itinerary Management",
            description:
                "We take care of all your airline needs — from reservations and ticket bookings to full itinerary management — so you can focus on what matters most.",
            features: [
                "Flight reservations across all major airlines",
                "Business & first class ticket bookings",
                "Complete multi-leg itinerary planning",
                "Last-minute & urgent booking handling",
                "Group & delegation travel coordination",
                "Real-time flight change & rebooking management",
            ],
            cta: "Enquire Now",
        },
        {
            id: 6,
            slug: "delegation-handling",
            category: "limousine",
            icon: "◆",
            title: "Official Delegation Handling",
            subtitle: "International Organisations & Diplomatic Missions",
            description:
                "Eleego is experienced in servicing high-profile clients, including international organisations and diplomatic missions based in Geneva, with the utmost discretion and professionalism.",
            features: [
                "Protocol-compliant transport solutions",
                "Diplomatic mission support in Geneva",
                "Multi-vehicle fleet for large delegations",
                "Strict confidentiality & NDA compliance",
                "Multilingual, trained chauffeurs",
                "Priority on-demand availability",
            ],
            cta: "Enquire Now",
        },
        {
            id: 7,
            slug: "special-occasions",
            category: "limousine",
            icon: "♛",
            title: "Special Occasion Transportation",
            subtitle: "Weddings, Galas & Exclusive Events",
            description:
                "Make your most special moments unforgettable with our elegant occasion transportation. From weddings to black-tie galas, we ensure every arrival and departure is a statement.",
            features: [
                "Decorated vehicles tailored to your theme",
                "Fleet coordination for weddings & galas",
                "Red-carpet arrival service",
                "Champagne & personalised touches on board",
                "Multi-stop event day itinerary",
                "Professional & discreet chauffeurs",
            ],
            cta: "Enquire Now",
        },
        {
            id: 8,
            slug: "cargo-logistics",
            category: "limousine",
            icon: "◉",
            title: "Cargo & Logistics Services",
            subtitle: "Secure Transfer of Personal Belongings",
            description:
                "Beyond passengers, we provide secure and discreet transfer of personal belongings, valuables, and cargo — handled with the same white-glove care as our passenger services.",
            features: [
                "Secure transport of personal belongings & valuables",
                "Document & high-value item delivery",
                "Time-sensitive logistics coordination",
                "Insured transport for high-value goods",
                "Airport-to-destination cargo transfers",
                "Corporate & private logistics solutions",
            ],
            cta: "Enquire Now",
        },
        {
            id: 9,
            slug: "winter-transfers",
            category: "limousine",
            icon: "❄",
            title: "Winter Destination Transfers",
            subtitle: "Luxury Transfers to the Alps & Beyond",
            description:
                "Eleego specialises in luxury transportation to the most exclusive winter destinations in Switzerland and Europe. Arrive in style — whatever the conditions on the road.",
            features: [
                "Transfers to Zermatt, St. Moritz, Verbier & Gstaad",
                "Courchevel & Val d'Isère also covered",
                "Snow-equipped luxury vehicles",
                "Private chauffeur for ski trips & winter excursions",
                "Luggage & ski equipment assistance",
                "Flexible departure times",
            ],
            cta: "Book Transfer",
        },
        {
            id: 10,
            slug: "davos-wef",
            category: "limousine",
            icon: "◆",
            title: "Davos WEF Special Services",
            subtitle: "Dedicated Transport for High-Profile Events",
            description:
                "Eleego provides dedicated chauffeur-driven transport for attendees of the Davos World Economic Forum (WEF) and other high-profile business events, ensuring seamless, discreet logistics.",
            features: [
                "VIP transfers from Zurich & Geneva airports to Davos",
                "Luxury transport for corporate delegations",
                "Hourly & daily chauffeur service for event attendees",
                "Strict confidentiality & security protocols",
                "Multi-vehicle fleet coordination",
                "Priority on-demand availability",
            ],
            cta: "Enquire Now",
        },
        {
            id: 11,
            slug: "tour-travel",
            category: "limousine",
            icon: "✈",
            title: "Tour & Travel Services",
            subtitle: "Tailor-Made Private Tours Across Europe",
            description:
                "Eleego offers exclusive private tours to some of the most iconic destinations in Switzerland and Europe. Whether a cultural journey, nature excursion, or city exploration, we craft bespoke itineraries for a truly personal luxury experience.",
            features: [
                "Private guided tours across Switzerland & Europe",
                "Cultural, nature & city exploration packages",
                "Tailor-made itineraries to your schedule",
                "Multilingual chauffeur-guides available",
                "Luxury vehicles for all group sizes",
                "Flexible departure & return arrangements",
            ],
            cta: "Plan Your Tour",
        },
    ];

    const handleCta = (service: typeof services[0]): string => {
        if (service.slug) {
            return `${routes.serviceDetail}?service=${service.slug}`;
        }
        if (service.cta === "Browse Cars") {
            return `${routes.listinggrid}?category=rental`;
        }
        return `${routes.listinggrid}?category=limousine`;
    };

    return (
        <>
            <Breadcrumbs title="Our Services" subtitle="Services" maintitle="" />

            {/* ── Intro ── */}
            <section className="services-page-intro">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 text-center" data-aos="fade-up">
                            <span className="services-page-label">What We Offer</span>
                            <h2 className="services-page-headline">
                                Premium Transportation
                            </h2>
                            <p className="services-page-subtext">
                                From private limousine hire to flexible car rental, every
                                Eleego service is designed around a single standard — excellence.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── Services Grid ── */}
            <section className="services-page-grid">
                <div className="container">
                    <div className="row g-4">
                        {services.map((service, idx) => (
                            <div
                                className="col-lg-6"
                                key={service.id}
                                data-aos="fade-up"
                                data-aos-delay={idx * 100}
                            >
                                <div className="service-card-luxury">
                                    <div className="scl-accent-bar" />
                                    <div className="scl-header">
                                        <div className="scl-icon">{service.icon}</div>
                                        <div className="scl-title-group">
                                            <h3 className="scl-title">{service.title}</h3>
                                            <span className="scl-subtitle">{service.subtitle}</span>
                                        </div>
                                    </div>
                                    <div className="scl-divider" />
                                    <p className="scl-desc">{service.description}</p>
                                    <ul className="scl-features">
                                        {service.features.map((f, i) => (
                                            <li key={i}>
                                                <span className="scl-check">✓</span>
                                                {f}
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="scl-footer">
                                        <Link
                                            to={handleCta(service)}
                                            className="btn scl-btn"
                                        >
                                            {service.cta}
                                            <span className="scl-btn-arrow">→</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── CTA Banner ── */}
            <section className="services-cta-section">
                <div className="container">
                    <div className="services-cta-card" data-aos="fade-up">
                        <div className="scc-gold-line top" />
                        <div className="row align-items-center">
                            <div className="col-lg-8">
                                <h3 className="scc-title">Looking for a bespoke solution?</h3>
                                <p className="scc-text">
                                    Contact our team and we&apos;ll curate a transport experience
                                    tailored precisely to your needs.
                                </p>
                            </div>
                            <div className="col-lg-4 text-lg-end mt-4 mt-lg-0">
                                <Link to={routes.contact} className="btn scc-btn">
                                    Get In Touch →
                                </Link>
                            </div>
                        </div>
                        <div className="scc-gold-line bottom" />
                    </div>
                </div>
            </section>
        </>
    );
};

export default ServicesPage;
